import { apiConnection } from "@/services/api-connection";

class TemplateManager {
  updateConditions(templateType, id, params = {}) {
    const url = "/app/admin/template/" + templateType + "/update-conditions/" + id;
    return apiConnection.put(url, params);
  }

  getTemplateToEdit(templateType, id) {
    const url = "/app/admin/template/" + templateType + "/edit/" + id;
    return apiConnection.get(url);
  }

  async removeModels(row, templateType) {
    const url = "/app/admin/template/" + templateType + "/delete/" + row.id;
    return await apiConnection.delete(url, {});
  }

  async duplicateModels(row, templateType) {
    const url = "/app/admin/template/" + templateType + "/duplicate/" + row.id;
    return await apiConnection.post(url, {});
  }
}

export const templateManager = new TemplateManager();
